import { useState } from 'react'

import { useScaVerificationBase } from '../../hooks/useScaVerificationBase'

export const useOneTimeScaVerificationPresenter = ({
  onError,
  phoneNumber = '',
}: {
  onError: (error: Error) => void
  phoneNumber?: string
}) => {
  const [scaToken, setScaToken] = useState<string | undefined>(undefined)
  const [scaSessionCode, setScaSessionCode] = useState<string | undefined>(
    undefined
  )

  const [enabled, setEnabled] = useState(false)

  const { isLoading, isInitialized, openScaVerificationModal } =
    useScaVerificationBase({
      enabled,
      onError,
      phoneNumber,
      onInitialized: () => {
        if (scaSessionCode) {
          openScaVerificationModal(scaSessionCode)
        }
        return Promise.resolve()
      },
      onVerified: (token: string) => setScaToken(token),
    })

  return {
    data: { scaToken },
    commands: {
      verifyIdentity: (sessionCode: string) => {
        setScaSessionCode(sessionCode)

        if (isInitialized) {
          openScaVerificationModal(sessionCode)
        } else {
          setEnabled(true)
        }
      },
    },
    states: {
      isLoading,
    },
  }
}
